<template>
	<CreationWizardStepHeaderWrapper v-bind="headerWrapperProps" v-on="headerWrapperListeners">
		<h1 class="med">To add add-ons - use the extension</h1>
	</CreationWizardStepHeaderWrapper>
</template>

<script>
import WizardStepMixin from '../WizardStepMixin';
import props from './GoToExtToInstallAddOn.props';
export default {
	name: 'GoToExtToInstallAddOnHeader',
	mixins: [WizardStepMixin],
	props,
};
</script>

<style lang="scss" scoped></style>
